import { Button, Flex, Text } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';

export const ReadOnly = ({
  onClick,
  showEditButton,
}: {
  onClick: () => void;
  showEditButton: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Flex w="100%" justify="space-between" align="center">
      <Text size={16} fw={600} c="gray.9">
        *****
      </Text>
      {showEditButton && (
        <Button variant="default" size="sm" radius="md" onClick={onClick}>
          {t('설정')}
        </Button>
      )}
    </Flex>
  );
};
